function Field({children}) {
    return <div className={'field'}>
        {children}
    </div>;
}

export default Field;